<template>
    <div :class="`mobile-menu ${opened ? 'opened' : ''}`">
        <div class="mm-wrap">
            <div class="wrapper">
                <base-menu
                    v-if="opened"
                    class="menu"
                    :menu="menu"
                    @menuClicked="handleClickedMenu"
                />
                <button v-if="isAuthenticated" class="btn btn-upgrade" @click="$router.push({ name: 'user-credits' })">{{ 'Upgrade' | translate }}</button>
                <hr v-if="isAuthenticated" />
                <div v-if="isAuthenticated"  class="btm-text-con">
                    <p v-if="gender == 'male'" class="credits" @click="$router.push({ name: 'user-credits' })">{{ credits }} {{ 'Credits' | translate }}</p>
                    <p v-if="subscriptionAllowed" class="premium" @click="$router.push({ name: 'user-premium' })"> {{ $t('You have {count} days premium left', { count: premiumDaysRemaining }) }} </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainFooter from '@views/common/MainFooter/main_footer'
    import BaseMenu from '@theme-views/common/BaseMenu'

    export default {
        mixins: [MainFooter],
        name: 'mobile-menu',
        data() {
            return {
                opened: false
            }
        },
        components: {
            BaseMenu
        },
        props: {
            initOpened: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            openMenu() {
                if(this.opened) {
                    this.$root.$children[0].$refs['app-con'].classList.remove('modal-open')
                } else {
                    this.$root.$children[0].$refs['app-con'].classList.add('modal-open')
                }
                this.opened = !this.opened
            },
            closeMenu() {
                this.$root.$children[0].$refs['app-con'].classList.remove('modal-open')
                this.opened = false
            },
            handleClickedMenu() {
                EventBus.$emit('menu-clicked')
            }
        },
        computed: {
            menu() {
                return this.sub_menu_1.concat( this.sub_menu_2 )
            },
            gender() {
                return this.$store.getters['auth/profile']['sex']
            },
            credits() {
                return this.$store.getters['auth/credits']
            },
            premiumDaysRemaining() {
                return this.$store.getters['auth/premiumDaysRemaining']
            },
            isAuthenticated() {
                return this.$store.getters['auth/isAuthenticated']
            },
            subscriptionAllowed() {
                return this.$store.getters['auth/profile']?.subscription_allowed
            }
        },
        created() {
            this.opened = this.initOpened
            // move FAQ to top
            this.sub_menu_2.splice(2, 1)
            this.sub_menu_1.unshift({ name: 'FAQ', route: 'faq' })
        }
    }
</script>

<style lang="scss" src="./mobile_menu.scss"></style>
